export const faqs = [
  {
    q: '¿Sirve para cualquier nivel de grupo?',
    a: 'Sí. Cada sesión incluye Versión A para principiantes, Versión B para intermedios y Versión C para avanzados. Puedes dictar la misma clase a un grupo mixto sin problema.',
  },
  {
    q: '¿En qué moneda pago?',
    a: 'El precio está en dólares, pero el cobro se realiza en tu moneda local: la conversión es automática al finalizar la compra. No necesitas cuenta en dólares.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'Acceso inmediato en 5 minutos. Después de pagar, recibes un email con tu link personal. Descargas los 6 Tomos en PDF — los archivos son tuyos PARA SIEMPRE. Puedes imprimirlos o usarlos directamente desde tu celular, tablet o computadora.',
  },
  {
    q: '¿Necesito equipamiento especial para usarlo?',
    a: 'NO — Equipamiento básico solamente. Cada sesión usa: barras, mancuernas, kettlebells, cajones, TRX, colchonetas. Si tu gimnasio tiene lo básico, YA ESTÁ.',
  },
  {
    q: '¿Funciona si soy instructor de gimnasio y no profesor de escuela?',
    a: 'SÍ — El 70% de nuestros clientes son instructores de gimnasio. El MEGAPACK sirve para profesores, instructores de gym, coaches de CrossFit, entrenadores personales y preparadores físicos.',
  },
  {
    q: '¿Tiene garantía real?',
    a: '100% real — Sin formularios, sin complicaciones. Si compras hoy y en 7 días no te gusta, escribes un email y te devolvemos el dinero. No preguntamos por qué. Menos del 2% pide devolución.',
  },
  {
    q: 'Soy principiante, ¿necesito conocimientos en programación?',
    a: 'NO. No necesitas saber de periodización ni teoría avanzada. Cada sesión YA ESTÁ armada con objetivo, ejercicios y series. Abres, lees, dictas. Funciona para coaches nuevos y profesionales. El 40% de nuestros clientes son coaches que recién empiezan.',
  },
  {
    q: '¿Puedo usar el MEGAPACK con más de un grupo?',
    a: 'SÍ — Uso ilimitado con todos tus grupos. Un pago = acceso para siempre. Usas el MEGAPACK con 1 grupo, 5 grupos, o 20 grupos. No hay restricción.',
  },
]
